import { SheetState } from '../sheetTypes';

export const isElementEditorSheet = (sheetState: SheetState): boolean => !!sheetState.config?.containsElementEditor;
export const isNotElementEditorSheet = (sheetState: SheetState): boolean => !isElementEditorSheet(sheetState);
